import { render, staticRenderFns } from "./s-concat.vue?vue&type=template&id=1559d3f2&scoped=true&"
import script from "./s-concat.vue?vue&type=script&lang=js&"
export * from "./s-concat.vue?vue&type=script&lang=js&"
import style0 from "./s-concat.vue?vue&type=style&index=0&id=1559d3f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1559d3f2",
  null
  
)

export default component.exports